import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Column } from 'react-table'
import { BaseTable, IColumn } from 'src/components/BaseTable'
import { useConfigTable } from 'src/hooks/useConfigTable'
import { tableStore } from 'src/stores/TableStore'
import { resourceTabela } from 'src/utils/resourcesTabela'
import { AddRecord, Paper, TableContainer } from '../../components'
import NoResultsTable from '../../components/NoResultsTable'
import Spacer from '../../components/Spacer'
import { AgrupadoresProdutosColumns } from './AgrupadoresProdutosColumns'
import { agrupadoresProdutosStore } from './stores'
import { AgrupadorProdutosDetail } from './types'

interface Props {
  onDelete: (id: string) => void
  checks?: {
    ids: string[]
    onCheck: (id: string) => void
  }
  authorization?: {
    canCreate: boolean
    canDelete: boolean
    canUpdate: boolean
  }
}

export const AgrupadoresProdutosTable = observer(
  ({ onDelete, authorization }: Props) => {
    const KEY_TABLE = resourceTabela.AGRUPADORES_PRODUTOS
    useConfigTable(KEY_TABLE)
    const tableState = tableStore.getState(KEY_TABLE)
    const isTableReady =
      !agrupadoresProdutosStore.agrupadoresProdutos.isLoading &&
      tableState &&
      agrupadoresProdutosStore.agrupadoresProdutos.list.length

    const { pathname } = useLocation()

    const columns: Array<Column & IColumn> = useMemo(
      () => AgrupadoresProdutosColumns({ onDelete, authorization }),
      [onDelete, authorization]
    )

    const rows = agrupadoresProdutosStore.agrupadoresProdutos.list.map(
      ({ ...agrupadores }: AgrupadorProdutosDetail) => {
        return {
          ...agrupadores
        }
      }
    )

    return (
      <>
        <Spacer y={4} />
        <Paper>
          <TableContainer
            loading={agrupadoresProdutosStore.agrupadoresProdutos.isLoading}
            totalCount={agrupadoresProdutosStore.agrupadoresProdutos.totalCount}
          >
            {isTableReady ? (
              <BaseTable
                keyTable={KEY_TABLE}
                columns={columns}
                hasConditionClickRow={false}
                linkWithRedirectClickRow={pathname}
                data={rows}
              />
            ) : (
              <NoResultsTable
                loading={agrupadoresProdutosStore.agrupadoresProdutos.isLoading}
              />
            )}
          </TableContainer>
          <AddRecord path={pathname} authorization={authorization} />
        </Paper>
      </>
    )
  }
)
